import axios, { getAuthHeaders } from "./config";

export default {
    initialize: function() {
        return axios.get("file-manager/initialize", { 
            headers: getAuthHeaders()
        });
    },

    tree: function(disk, path) {
        return axios.get("file-manager/tree", { 
            params : { disk, path },
            headers: getAuthHeaders()
        })
    },
    selectDisk: function(disk) {
        return axios.get("file-manager/select-disk", { 
            params : { disk },
            headers: getAuthHeaders()
        })
    },
    content: function(disk, path) {
        return axios.get("file-manager/content", { 
            params : { disk, path },
            headers: getAuthHeaders()
        })
    },
    search: function(disk, path, searchText) {
        return axios.get("file-manager/search", { 
            params : { disk, path, searchText },
            headers: getAuthHeaders()
        })
    },
    oldVersions: function(document_id) {
        return axios.get(`file-manager/old-versions/${document_id}`, {
            headers: getAuthHeaders()
        })
    },
    url: function(disk, path) {
        return axios.get('file-manager/url', {
            params: { disk, path },
            headers: getAuthHeaders()
        })
    },
    getFile: function(disk, path) {
        return axios.get('file-manager/download', {
            params: { disk, path },
            headers: getAuthHeaders()
        })
    },
    getFilePath: function(id) {
        return axios.get('file-manager/document-path', {
            params: { id },
            headers: getAuthHeaders()
        })
    },
    getOldFile: function(disk, path) {
        return axios.get('file-manager/download-old-file', {
            params: { disk, path },
            responseType: "blob",
            headers: getAuthHeaders()
        })
    },
    getAttachment: function(disk, path) {
        return axios.get('file-manager/download-old-file', {
            params: { disk, path },
            responseType: "blob",
            headers: getAuthHeaders()
        })
    },
    getFileArrayBuffer(disk, path) {
      return axios.get('file-manager/download', {
        responseType: 'arraybuffer',
        params: { disk, path },
        headers: getAuthHeaders()
      });
    },
    thumbnail(disk, path) {
      return axios.get('file-manager/thumbnails', {
        responseType: 'arraybuffer',
        params: { disk, path },
        headers: getAuthHeaders()
      });
    },
    preview(disk, path) {
      return axios.get('file-manager/preview', {
        responseType: 'arraybuffer',
        params: { disk, path },
        headers: getAuthHeaders()
      });
    },
    download(disk, path) {
      return axios.get('file-manager/download', {
        responseType: 'arraybuffer',
        params: { disk, path },
        headers: getAuthHeaders()
      });
    },
    deleteVersion(versionId) {
        return axios.delete(`file-manager/documents/versions/${versionId}`, {
            headers: getAuthHeaders()
        });
    },
    shareList(id, type) {
        return axios.get(`file-manager/share`, {
            params: { id, type },
            headers: getAuthHeaders()
        });
    }
} 